export const PURPLE = '#5236AB';
export const PAIR_COLOR = '#4FB3E8';

const styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  chartWrapper: {
    position: 'relative',
    flex: '1 1 auto',
    minHeight: 0,
    minWidth: 0,
    p: 0.5,
    overflow: 'visible',
  },
  chartText: {
    '& .recharts-text': {
      fontSize: 'clamp(9px, 1.1vw, 12px)',
    },
  },
};

export const rechartsStyles = {
  margin: { top: 4, right: 12, left: 6, bottom: 24 },
  tooltip: { fontSize: 10, padding: '4px 8px' },
};

export default styles;
